import { cardsData } from '@/mocks/homeData';

export default function CardsSection() {
  return (
    <section id="cards" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <h2 className="text-xl md:text-2xl font-heading text-foreground-950 text-center mb-2">热门爆料</h2>
        <p className="text-sm text-foreground-500 text-center mb-8 md:mb-10">最新最全的娱乐八卦资讯</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {cardsData.map((card) => (
            <article key={card.id} className="bg-background-50 rounded-lg overflow-hidden border border-background-200 flex flex-col group cursor-pointer hover:border-primary-200 transition-colors">
              <div className="relative aspect-[3/2] overflow-hidden bg-background-100">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-2 py-1 rounded text-[10px] font-semibold bg-secondary-500 text-background-50 whitespace-nowrap">
                  {card.category}
                </span>
              </div>
              <div className="p-3 md:p-4 flex flex-col gap-2 flex-1">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 leading-snug group-hover:text-primary-600 transition-colors">
                  {card.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">{card.excerpt}</p>
                <div className="flex items-center justify-between mt-auto pt-2 text-xs text-foreground-400">
                  <span>{card.time}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {card.views}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}